const CURRENCY_CONFIG = {
  EUR: {
    code: "EUR",
    symbol: "€",
    locale: "en-IE",
  },
  GBP: {
    code: "GBP",
    symbol: "£",
    locale: "en-GB",
  },
};

export function getCurrency(currency = "EUR") {
  return CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.EUR;
}

export function getCurrencySymbol(currency = "EUR") {
  return getCurrency(currency).symbol;
}

export function formatCurrency(
  value,
  currency = "EUR",
  decimals = 0
) {
  const config = getCurrency(currency);

  return new Intl.NumberFormat(config.locale, {
    style: "currency",
    currency: config.code,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(value) || 0);
}
